import { Youtube, Instagram, Facebook, Twitter } from "lucide-react";
import { Link } from "react-router-dom"; // IMPORT THIS
import logoWebp64 from "@/assets/logo-64.webp";
import logoPng64 from "@/assets/logo-64.png";

const footerLinks = {
  product: [
    { label: "Pricing", href: "/pricing" },
    { label: "Solutions & Compare", href: "/solutions" }, // NEW LINK
    { label: "Refund Policy", href: "/refund" },
    { label: "Documentation", href: "/documentation" },
  ],
  company: [
    { label: "About Us", href: "/about" },
    { label: "Careers", href: "/careers" },
    { label: "Contact Us", href: "/contact" },
  ],
  legal: [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" },
    { label: "Guidelines", href: "/guidelines" },
    { label: "Vulnerability", href: "/vulnerability" },
    { label: "Security Architecture", href: "/security-architecture" },
  ],
};

const socialLinks = [
  { icon: Youtube, href: "https://youtube.com/@clear_makes", label: "YouTube" },
  { icon: Instagram, href: "https://www.instagram.com/clearmakes2025", label: "Instagram" },
  { icon: Facebook, href: "https://m.facebook.com/profile.php?id=61581289796133", label: "Facebook" },
  { icon: Twitter, href: "https://x.com/clearmakes2025", label: "X" },
];

export const Footer = () => {
  return (
    <footer className="py-16 border-t border-white/5 relative bg-[#0A0F1C]">
      <div className="absolute inset-0 noise-texture opacity-20 pointer-events-none" />
      
      <div className="container relative z-10">
        <div className="grid md:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <picture>
                <source srcSet={logoWebp64} type="image/webp" />
                <img src={logoPng64} alt="ClearMakes" className="w-8 h-8 rounded-lg" />
              </picture>
              <span className="text-xl font-bold tracking-tight text-white">ClearMakes</span>
            </div>
            <p className="text-muted-foreground text-sm mb-6">
              Intelligent Communication, Automated.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-muted-foreground hover:text-white hover:bg-white/10 transition-all hover:-translate-y-0.5"
                  aria-label={social.label}
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="font-semibold mb-4 text-sm text-white">Product</h3>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.href}>
                  <Link 
                    to={link.href}
                    className="text-sm text-muted-foreground hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="font-semibold mb-4 text-sm text-white">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.href}>
                  <Link 
                    to={link.href}
                    className="text-sm text-muted-foreground hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="font-semibold mb-4 text-sm text-white">Legal</h3>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.href}>
                  <Link 
                    to={link.href}
                    className="text-sm text-muted-foreground hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="text-center pt-8 border-t border-white/5">
          <p className="text-xs text-muted-foreground mb-4 max-w-2xl mx-auto">
            Please Note: ClearMakes leverages advanced AI for summaries and automation. While we aim for high accuracy, AI systems can sometimes make mistakes. We advise reviewing critical communications or actions suggested by the AI.
          </p>
          <p className="text-xs text-muted-foreground">
            © 2026 ClearMakes. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};